module.exports = __webpack_public_path__ + "img/hero-bg.f707ab6a.png";